import { AnimatePresence, motion } from 'framer-motion';

import { useToast } from '@/stores/useToast';
import { cn } from '@/lib/utils';

const variantClasses: Record<string, string> = {
  success: 'bg-success text-white',
  error: 'bg-pepper text-white',
  info: 'bg-ink text-paper',
};

const variantIcons: Record<string, string> = {
  success: '✓',
  error: '!',
  info: '·',
};

/**
 * Toast stack — global, fixed top, max 3 visible. Auto-dismisses via the store.
 */
export function ToastViewport() {
  const toasts = useToast((s) => s.toasts);

  return (
    <div className="pointer-events-none fixed inset-x-0 top-3 z-[100] flex flex-col items-center gap-2 px-4 pt-safe">
      <AnimatePresence>
        {toasts.slice(-3).map((t) => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: -16, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8, scale: 0.95 }}
            transition={{ duration: 0.2, ease: [0.2, 0.8, 0.2, 1] }}
            className={cn(
              'pointer-events-auto flex items-center gap-3 rounded-pill px-4 py-2.5 text-sm font-medium shadow-[0_10px_30px_rgba(0,0,0,0.25)]',
              variantClasses[t.variant] ?? variantClasses.info,
            )}
          >
            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-white/20 text-xs font-bold">
              {variantIcons[t.variant]}
            </span>
            <span>{t.text}</span>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
